(function() { window.GUID_81fdbf4b_76ab_43c8_8093_3a37e7859b0b = { getGuid: function() { return "81fdbf4b-76ab-43c8-8093-3a37e7859b0b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ControlValueBase extends Controls.ControlBase {
            OnDispose() {
                this.$Control.off("change.ControlValueBase" + this.UniqueNamespace);
            }
            constructor(...params) {
                super(...params); //Pourrais donner un Array de array.... 
                $(() => {
                    this.$Control.offon("change.ControlValueBase" + this.UniqueNamespace, (event) => {
                        this.RaiseChange(event);
                    });
                });
            }
            RaiseChange(event) {
                this.Trigger(ControlValueBase.EventNames.ValueChange, { jqueryEventObject: event, data: this.val() });
            }
            val(value) {
                if (typeof (value) != "undefined") {
                    this.$Control.val(value);
                }
                else {
                    return this.$Control.val();
                }
            }
            get $OriginalInput() {
                if (!this.$originalInput) {
                    this.$originalInput = this.$Control.find('.original-value');
                }
                return this.$originalInput;
            }
            GetValue() {
                return this.$Control.val();
            }
            GetOriginalValue() {
                if (this.$OriginalInput.length == 0) {
                    return this.$Control.data('original');
                }
                else {
                    return this.$OriginalInput.val();
                }
            }
            SetOriginalValue(value) {
                if (this.$OriginalInput == null || this.$OriginalInput.length == 0) {
                    this.$Control.data('original', value);
                }
                else {
                    this.$OriginalInput.val(value);
                }
            }
            DifferentThanOriginal() {
                return this.GetOriginalValue() !== this.GetValue();
            }
            SetValue(value, bypassEvents = null) {
                this.$Control.val(value);
            }
            ResetToOriginalValue() {
                this.SetValue(this.GetOriginalValue());
            }
            ClearValue() {
                this.SetValue(null);
            }
        }
        Controls.ControlValueBase = ControlValueBase;
        (function (ControlValueBase) {
            class Events {
                /**
                 * Raised when the change (When JQuery.change is raised)
                 * @param param
                 */
                static ValueChange(controlConstructor, param) {
                    Controls.RegisterEvent(controlConstructor, EventNames.ValueChange, param);
                }
            }
            ControlValueBase.Events = Events;
            class EventNames {
            }
            EventNames.ValueChange = "controlbase-value-change";
            ControlValueBase.EventNames = EventNames;
        })(ControlValueBase = Controls.ControlValueBase || (Controls.ControlValueBase = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=control-value-base.pre.js.map
